import React from "react"
import { PropTypes } from "prop-types"
import UniqId from "uniqid"
import { withNamespaces } from "react-i18next"
import { compose } from "redux"
import HomeSafeties from "../../common/constants/home_safeties"
import "./HomeSafety.scss"

const HomeSafety = (props) => {
  const { t } = props

  const needToDisplay = () => {
    return props.home_safeties.some((e) => {
      return e.flg
    })
  }

  const homeSafetiesTranslate = (name) => {
    if (props.lng == "ja") {
      return name
    }

    return HomeSafeties[props.lng + "_translation_mapping"][name]
  }

  return (
    <React.Fragment>
      {needToDisplay() && (
        <section>
          <h2>{t("home_safety.title")}</h2>
          <ul styleName="home-safety-list">
            {props.home_safeties.map((e) => {
              return (
                e.flg && (
                  <li styleName="home-safety-item" key={UniqId()}>
                    {homeSafetiesTranslate(e.name)}
                  </li>
                )
              )
            })}
          </ul>
        </section>
      )}
    </React.Fragment>
  )
}

HomeSafety.propTypes = {
  home_safeties: PropTypes.array.isRequired
}

HomeSafety.defaultProps = {
  home_safeties: []
}

export default compose(withNamespaces("listings"))(HomeSafety)
